import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  styled,
  TableCell,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import SearchIcon from '@mui/icons-material/Search';
import Table from '../../../components/Table';
import { useEffect, useState } from 'react';
import { Company } from '../../../schema/company';
import { api } from '../../../api';
import { TableResponse } from '../../../schema/helper';
import { Link } from 'react-router-dom';

const tableHead = [
  'เลขบัตรประชาชน',
  'หมายเลขบัตร',
  'ชื่อ นามสกุล',
  'บริษัท',
  'บุคคลประเภท',
  'ผู้คุมงาน',
  'สถานะ',
  'Actions'
];

interface ReportInPeople {
  person_id: number;
  person_type_id: number;
  personnal_id: string;
  exchange_card_id?: string;
  name: string;
  person_type: string;
  company: string;
  supervisor: string;
  status_id: number;
  status: string;
}
const ReportInPeople = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filterID, setFilterID] = useState<string>('');
  const [filterName, setFilterName] = useState<string>('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [filterCompanyIDList, setFilterCompanyIDList] = useState<string[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [companies, setCompanies] = useState<Company[]>([]);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [filterStatus, setFilterStatus] = useState<string>('');

  const [data, setData] = useState<TableResponse<ReportInPeople> | null>(null);

  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const handleExportCSVFile = () => {
    if (isExportLoading) {
      return;
    }
    const searchParams = new URLSearchParams();

    if (filterID) {
      searchParams.set('personal_id', `${filterID}`);
    }
    if (filterName) {
      searchParams.set('name', `${filterName}`);
    }
    if (filterCompanyIDList.length) {
      filterCompanyIDList.forEach((company_id) => {
        searchParams.append('company_id', `${company_id}`);
      });
    }
    setIsExportLoading(true);
    api
      .get(`/report-in/export`, { params: searchParams, responseType: 'blob' })
      .then((response) => {
        console.log(response)
        if (response.status == 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'report-in_export_data.xlsx');
          document.body.appendChild(link);
          link.click();
        } else {
          setOpenConfirmDialog(true);
        }
      })
      .catch(() => {
        setOpenConfirmDialog(true);
      })
      .finally(() => setIsExportLoading(false));
  };

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    setIsLoading(true)
    const timeOutId = setTimeout(() => {
      const searchParams = new URLSearchParams();

      if (filterID) {
        searchParams.set('personal_id', `${filterID}`);
      }
      if (filterName) {
        searchParams.set('name', `${filterName}`);
      }
      if (filterStatus) {
        searchParams.set('status_id', `${filterStatus}`);
      }
      if (filterCompanyIDList.length) {
        filterCompanyIDList.forEach((company_id) => {
          searchParams.append('company_id', `${company_id}`);
        });
      }
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api
        .get<TableResponse<ReportInPeople>>(`/report-in/table`, { params: searchParams })
        .then((res) => {
          const { data } = res;
          setData(data);
          setIsLoading(false)
        });
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [filterID, filterName, filterCompanyIDList, filterStatus, page, rowsPerPage]);

  useEffect(() => {
    api.get<Company[]>('/company').then((res) => {
      const { data } = res;
      setCompanies(data);
    });
  }, []);

  useEffect(() => {
    if (searchKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('company_name', searchKeyword);
        searchParams.set('limit', '10');

        api.get<Company[]>(`/company`, { params: searchParams }).then((res) => {
          const { data } = res;
          setCompanies(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchKeyword]);
  return (
    <Container>
      <PageHeader text="บุคคลที่ไม่ได้แลกบัตรออก" />
      <Grid container spacing={2} my={3}>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหาเลขบัตรประชาชน"
            variant="outlined"
            placeholder="ค้นหาเลขบัตรประชาชน"
            onChange={(event) => setFilterID(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete="off"
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหาชื่อ - นามสกุล"
            variant="outlined"
            placeholder="ค้นหาชื่อ - นามสกุล"
            onChange={(event) => setFilterName(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete={'off'}
          />
        </Grid>

        <Grid item md={3}>
          <Autocomplete
            multiple
            limitTags={2}
            disablePortal
            options={companies}
            getOptionLabel={(option) => option.company_name}
            renderInput={(params) => <TextField {...params} label="บริษัท" fullWidth />}
            onChange={(_, value) => setFilterCompanyIDList(value.map((data) => data.id.toString()))}
            onInputChange={(_, newInputValue) => {
              setSearchKeyword(newInputValue);
            }}
            fullWidth
          />
        </Grid>
        <Grid item md={2}>
          <FormControl fullWidth>
            <InputLabel>{`สถานะ`}</InputLabel>
            <Select
              label={`สถานะ`}
              variant="outlined"
              onChange={(e) => {
                setFilterStatus(e.target.value);
              }}
              value={filterStatus}
              autoComplete="off"
              required
            >
              <MenuItem value={'1'}>ยังไม่ได้แลกบัตรล่วงเวลา</MenuItem>
              <MenuItem value={'3'}>แลกบัตรล่วงเวลาแล้ว</MenuItem>
              <MenuItem value={'4'}>เจ้าหน้าที่</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={1} sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleExportCSVFile}
            disabled={isExportLoading}
          >
            Export
          </Button>
        </Grid>
      </Grid>
      <Table
        heads={tableHead}
        count={data?.total ? data.total : 0}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        isLoading={isLoading}
      >
        {data?.data.map((data, index) => (
          <TableRow key={index}>
            <TableCell align="center">{data.personnal_id}</TableCell>
            <TableCell align="center">{data.exchange_card_id}</TableCell>
            <TableCell align="center">{data.name}</TableCell>
            <TableCell align="center">{data.company}</TableCell>
            <TableCell align="center">{data.person_type}</TableCell>
            <TableCell align="center">{data.supervisor}</TableCell>
            <TableCell align="center">
              <Typography variant="body2" color={data.status_id == 1 ? 'error' : 'success.main'}>
                {data.status_id == 1
                  ? 'ยังไม่ได้แลกบัตรล่วงเวลา'
                  : data.status_id == 2
                  ? 'ยังไม่ได้คืนบัตร'
                  : data.status_id == 3
                  ? 'แลกบัตรล่วงเวลาแล้ว'
                  : data.status}
              </Typography>
            </TableCell>

            <TableCell align="center">
              <Button
                component={Link}
                to={`/person/${data.person_id}`}
                variant="contained"
                color="success"
              >
                ข้อมูล
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </Table>
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ px: 3 }} id="alert-dialog-title" variant="h5">
          เกิดข้อผิดพลาด
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            อาจมีข้อมูลที่มากเกินไปกรุณาคัดกรองข้อมูลก่อนการ Export
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 2 }}>
          <Button
            onClick={() => {
              setOpenConfirmDialog(false);
              setTimeout(() => {
                document.getElementById('personGPSDevice')?.focus();
              }, 300);
            }}
            color="error"
            autoFocus
          >
            รับทราบ
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ReportInPeople;

const Container = styled('div')`
  padding: 16px;
`;
